export default __webpack_public_path__ + "static/media/placeholder_dummy2016-allgemeinarzt01-de.f1569bdc.png";